import type { FaceUiConfiguration, HTMLFacetUiElement } from '@innovatrics/dot-auto-capture-ui/face';

import '@innovatrics/dot-auto-capture-ui/face';
import { useEffect } from 'react';

export const FaceCameraUi = (props: FaceUiConfiguration) => {
  useEffect(() => {
    const uiElement = document.getElementById('x-dot-face-auto-capture-ui') as HTMLFacetUiElement | null;

    if (uiElement) {
      uiElement.configuration = props;
    }
  });

  return <x-dot-face-auto-capture-ui id="x-dot-face-auto-capture-ui" />;
};
